// Imports
import Axios from 'axios'

const serverUrl = process.env.VUE_APP_SERVER_ENV === 'staging' ? 'https://dev.api.lens.foreplay.co' : 'https://api.lens.foreplay.co'
// Axios Config
const AxiosConfig = Axios.create({
  // baseURL: 'http://localhost:3000'
  baseURL: serverUrl
})

export default AxiosConfig
